import { leftPad } from './string';

const _weekdays = new Map([
  [0, 'Sunday'],
  [1, 'Monday'],
  [2, 'Tuesday'],
  [3, 'Wednesday'],
  [4, 'Thursday'],
  [5, 'Friday'],
  [6, 'Saturday'],
]);

const _weekdaysShort = new Map([
  [0, 'Su'],
  [1, 'Mo'],
  [2, 'Tu'],
  [3, 'We'],
  [4, 'Th'],
  [5, 'Fr'],
  [6, 'Sa'],
]);

let _events = {
  dateChange: {},
  hoursChange: {},
  minutesChange: {},
  secondsChange: {}
}

let _state = {
  date: new Date().getDate(),
  hours: new Date().getHours(),
  minutes: new Date().getMinutes(),
  seconds: new Date().getSeconds(),
};

const _interval = window.setInterval(function() {
  const now = new Date();
  const nowDate = now.getDate();
  const nowHours = now.getHours();
  const nowMinutes = now.getMinutes();
  const nowSeconds = now.getSeconds();

  if (nowDate !== _state.date) {
    _state.date = nowDate;
    Object.keys(_events.dateChange).forEach(eventID => {
      return _events.dateChange[eventID](now);
    });
  }

  if (nowHours !== _state.hours) {
    _state.hours = nowHours;
    Object.keys(_events.hoursChange).forEach(eventID => {
      return _events.hoursChange[eventID](now);
    });
  }

  if (nowMinutes !== _state.minutes) {
    _state.minutes = nowMinutes;
    Object.keys(_events.minutesChange).forEach(eventID => {
      return _events.minutesChange[eventID](now);
    });
  }

  if (nowSeconds !== _state.seconds) {
    _state.seconds = nowSeconds;
    Object.keys(_events.secondsChange).forEach(eventID => {
      return _events.secondsChange[eventID](now);
    });
  }
}, 1000);

const getDateFromSeconds = function(seconds) {
  return new Date(seconds * 1000);
};

const getDateFrom24HourTimeString = function(timeString) {
  const hours = parseInt(timeString.split(':')[0], 10);
  const minutes = parseInt(timeString.split(':')[1], 10);

  return new Date(1, 1, 1, hours, minutes);
};

const getShortDayNameFromDayNumber = function(dayNumber) {
  return _weekdaysShort.get(dayNumber);
};

const getDayNameFromDayNumber = function(dayNumber) {
  return _weekdays.get(dayNumber);
};

const getDayName = function(date) {
  return getDayNameFromDayNumber(date.getDay());
};

const getDayNameShort = function(date) {
  return getShortDayNameFromDayNumber(date.getDay());
};

const getMonthDayYear = function(date) {
  return `${leftPad(date.getMonth() + 1)}.${leftPad(date.getDate())}.${date.getFullYear()}`;
};

const getWeekdaysShort = function() {
  return [..._weekdaysShort.values()];
}

const getWeekdaysShortStartingWithMonday = function() {
  let days = [..._weekdaysShort.values()];
  let sunday = days[0];
  let otherDays = days.slice(1,7);
  return otherDays.concat(sunday);
}

const get12HourTime = function(date) {
  let hours = date.getHours();
  let minutes = date.getMinutes();

  if (hours === 0) {
    hours = 12;
  } else if (hours > 12) {
    hours -= 12;
  }

  return `${hours}:${leftPad(minutes)}`;
};

const get12HourTimeHour = function(date) {
  let hours = date.getHours();

  if (hours === 0) {
    hours = 12;
  } else if (hours > 12) {
    hours -= 12;
  }

  return `${hours}`;
};

const get12HourPeriod = function(date) {
  if (date.getHours() >= 12) {
    return 'pm';
  }

  return 'am';
};

const getTimeUntil = function(end, start = new Date()) {
  const msUntil = end - start;
  const minutesUntil = Math.round(msUntil / 1000 / 60);
  const hoursUntil = Math.floor(minutesUntil / 60);
  const daysUntil = Math.floor(hoursUntil / 24);

  // occurs within the hour
  if (hoursUntil === 0) {
    return `${minutesUntil} minutes`;
  }
  // occurs within 24 hours
  else if (daysUntil === 0) {
    if(minutesUntil % 60 === 0) {
      return `${hoursUntil} hours`;
    } else {
      return `${hoursUntil} hours, ${minutesUntil % 60} ${minutesUntil % 60 === 1 ? 'minute' : 'minutes'}`;
    }
  }
  // occurs in 1 or more days
  else if (daysUntil === 1) {
    return `1 day`;
  }
  else {
    return `${daysUntil} days`;
  }
};

const addDateChangeEvent = function(eventID, fn) {
  _events.dateChange[eventID] = fn;
};

const removeDateChangeEvent = function(eventID) {
  delete _events.dateChange[eventID];
};

const addHoursChangeEvent = function(eventID, fn) {
  _events.hoursChange[eventID] = fn;
};

const removeHoursChangeEvent = function(eventID) {
  delete _events.hoursChange[eventID];
};

const addMinutesChangeEvent = function(eventID, fn) {
  _events.minutesChange[eventID] = fn;
};

const removeMinutesChangeEvent = function(eventID) {
  delete _events.minutesChange[eventID];
};

const addSecondsChangeEvent = function(eventID, fn) {
  _events.secondsChange[eventID] = fn;
};

const removeSecondsChangeEvent = function(eventID) {
  delete _events.secondsChange[eventID];
};

export {
  addDateChangeEvent,
  addHoursChangeEvent,
  addMinutesChangeEvent,
  addSecondsChangeEvent,
  get12HourPeriod,
  get12HourTime,
  get12HourTimeHour,
  getDateFromSeconds,
  getDateFrom24HourTimeString,
  getDayName,
  getDayNameShort,
  getDayNameFromDayNumber,
  getShortDayNameFromDayNumber,
  getTimeUntil,
  getMonthDayYear,
  getWeekdaysShort,
  getWeekdaysShortStartingWithMonday,
  removeDateChangeEvent,
  removeHoursChangeEvent,
  removeMinutesChangeEvent,
  removeSecondsChangeEvent,
}



// WEBPACK FOOTER //
// ./src/utils/datetime.js